import styled from 'styled-components'
import { STATUS } from '../../constants'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 1rem;

  .ant-form-item-no-colon {
    font-weight: bold;
    font-size: 13px;
  }

  .buttons {
    display: flex;
    gap: 0.25rem;

    button {
      flex: 1;
    }
  }
`

export const StatusButton = styled.button.attrs({ type: 'button' })`
  flex: 1;
  background: ${({ selected, value, theme }) => (selected ? (
    value === STATUS.NOT_STARTED
      ? theme.task_not_started
      : value === STATUS.IN_PROGRESS
        ? theme.task_in_progress
        : value === STATUS.COMPLETED
          ? theme.task_completed
          : '#fff'
  ) : '#fff')};
  border-radius: 6px;
  height: 40px;
  border: 1px solid #d9d9d9;
  color: #333;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`
